import { DEBUG } from "../../env";
let ROUTE = null;
if (DEBUG) {
   ROUTE = "http://iea-api.test/api/app/";
  //ROUTE = "http://192.168.100.6/iea-api/public/api/app/";
   
} else {
  ROUTE = "https://api.sistemaiea.com/api/app/";
  //ROUTE = "http://192.168.100.6/iea-api/public/api/app/";
  
}
export default ROUTE;
